import React from 'react'
import LogoImage from '../../assets/logo.png'

function Logo() {
  return (
    <div>
        <img src={LogoImage} alt='logo' width={67}/>
    </div>
  )
}

export default Logo